<template>
  <div class="bg relative h-full min-h-screen bg-class" :style="{ backgroundImage: 'url(' + require('@/assets/BG.png') + ')' }">
    

    <div class="p-10" style="max-width: 1200px; margin: auto;">
      <router-view />
    </div>

    <div class="pt-10"></div>
    <TheNavBar />
  </div>

  
</template>

<script>
import TheNavBar from '@/components/TheNavBar';
import TheFooter from '@/components/gem-farm/TheFooter';
import TheCat from '@/components/gem-farm/TheCat';
export default {
  components: { TheCat, TheFooter, TheNavBar },
};
</script>

<style>

input[type='radio']:checked + span {
  @apply text-black;
}

@font-face {
  font-family: 'segoeui';
  src: url(https://www.solminator.com/static/media/segoeui.6459be7b3f9441892a2a.eot);
  src: local('☺'), url(https://www.solminator.com/static/media/segoeui.9e35a1ed1e72f5673618.woff) format('woff'), url(https://www.solminator.com/static/media/segoeui.55d336ac99f56921ab9f.ttf) format('truetype'), url(https://www.solminator.com/static/media/segoeui.2ce0696eefaec9ddfe68.svg) format('svg');
  font-weight: normal;
  font-style: normal;
}

@font-face {
	font-family: 'segoeuibold';
	src: url(https://www.solminator.com/static/media/segoeuib.228eb51b0458d1d2fc21.eot);
	src: local('☺'), url(https://www.solminator.com/static/media/segoeuib.6760f10d178ee8551744.woff) format('woff'), url(https://www.solminator.com/static/media/segoeuib.bb81983dba8383dcb1a5.ttf) format('truetype'), url(https://www.solminator.com/static/media/segoeuib.ae09bd1b0567e22cd1e5.svg) format('svg');
	font-weight: normal;
	font-style: normal;
}


.bg-class{
    background-attachment: fixed;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
}

</style>
